import {
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  Typography,
  Button,
  Divider,
} from '@mui/material';

interface AgencyActionModalProps {
  open: boolean;
  mode: 'assign' | 'reassign';
  agencyName: string | undefined;
  onCancel: () => void;
  onConfirm: () => void;
  message?: string;
}

export const UnitAgencyActionModal = ({
  open,
  mode,
  agencyName,
  onCancel,
  onConfirm,
  message = 'Reassigning',
}: AgencyActionModalProps) => {
  const isAssign = mode === 'assign';

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: '20px',
          color: 'text.primary',
        }}
      >
        Agency Not Assigned to CFS
      </DialogTitle>

      <Divider />

      <DialogContent sx={{}}>
        {isAssign ? (
          <Typography sx={{ fontSize: '16px' }}>
            This unit belongs to {agencyName} and is not assigned to this CFS.
            Do you still want to assign the unit and the agency to the CFS?
          </Typography>
        ) : (
          <>
            <Typography sx={{ fontSize: '16px', mb: 1.5 }}>
              The selected unit does not belong to any agency currently assigned
              to this CFS. {message} this unit will automatically assign the
              agency {agencyName} to the CFS.
            </Typography>
          </>
        )}
      </DialogContent>

      <Divider />

      <Stack direction="row" justifyContent="flex-end" sx={{ m: 2 }}>
        <Button
          variant="outlined"
          color="inherit"
          size="large"
          sx={{ ml: 2, flex: 1 }}
          onClick={onCancel}
          fullWidth
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          size="large"
          sx={{ ml: 2, flex: 1 }}
          onClick={onConfirm}
          fullWidth
        >
          {isAssign ? 'Assign' : 'Proceed'}
        </Button>
      </Stack>
    </Dialog>
  );
};
